// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"175":"4f5eec3dd4c4a5e05eef","231":"b2d35ff9bb1952aa22d1","691":"1e2d4dfe871ac79ab158","774":"7965ebbf0063055f0083","987":"8d8bb6d9964c04e0f1e5"}[chunkId] + ".js";
};